import { Box, Grid } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { getEnvironmentVariable } from "../../../global/environmentVariables";

const canvasWidth = 1200;
const canvasHeight = 1200;
const defaultImages = [
  {
    x: 17,
    y: 40,
    sw: 180,
    sh: 254,
  },
  {
    x: 214,
    y: 40,
    sw: 180,
    sh: 254,
  },
  {
    x: 411,
    y: 40,
    sw: 180,
    sh: 254,
  },
  {
    x: 608,
    y: 40,
    sw: 180,
    sh: 254,
  },
  {
    x: 805,
    y: 40,
    sw: 180,
    sh: 254,
  },
  {
    x: 1002,
    y: 40,
    sw: 180,
    sh: 254,
  },

  // row 2
  {
    x: 17,
    y: 319,
    sw: 180,
    sh: 254,
  },
  {
    x: 214,
    y: 319,
    sw: 180,
    sh: 254,
  },
  {
    x: 411,
    y: 319,
    sw: 180,
    sh: 254,
  },
  {
    x: 608,
    y: 319,
    sw: 180,
    sh: 254,
  },
  {
    x: 805,
    y: 319,
    sw: 180,
    sh: 254,
  },
  {
    x: 1002,
    y: 319,
    sw: 180,
    sh: 254,
  },

  // row 3
  {
    x: 17,
    y: 598,
    sw: 180,
    sh: 254,
  },
  {
    x: 214,
    y: 598,
    sw: 180,
    sh: 254,
  },
  {
    x: 411,
    y: 598,
    sw: 180,
    sh: 254,
  },
  {
    x: 608,
    y: 598,
    sw: 180,
    sh: 254,
  },
  {
    x: 805,
    y: 598,
    sw: 180,
    sh: 254,
  },
  {
    x: 1002,
    y: 598,
    sw: 180,
    sh: 254,
  },

  // row 4
  {
    x: 17,
    y: 877,
    sw: 180,
    sh: 254,
  },
  {
    x: 214,
    y: 877,
    sw: 180,
    sh: 254,
  },
  {
    x: 411,
    y: 877,
    sw: 180,
    sh: 254,
  },
  {
    x: 608,
    y: 877,
    sw: 180,
    sh: 254,
  },
  {
    x: 805,
    y: 877,
    sw: 180,
    sh: 254,
  },
  {
    x: 1002,
    y: 877,
    sw: 180,
    sh: 254,
  },
];

export default function ArmyListSocialsView(props) {
  const deck = props.deck;

  const [pages, setPages] = useState(null);

  useEffect(() => {
    const go = async () => {
      setPages(null);
      let newPages = [];
      let cards = [];
      let sideCards = [];
      let categories = Object.values(deck?.armyListContent || {});
      categories.sort((a, b) => a.order - b.order);

      for (let category of categories) {
        if (category.cards) {
          let catCards = Object.values(category.cards);
          catCards.sort((a, b) => {
            if (category.name === "Character" && deck?.characterId) {
              if (a.id === deck.characterId) {
                return -1;
              }
              if (b.id === deck.characterId) {
                return 1;
              }
            }

            if (b.qty !== a.qty) {
              return b.qty - a.qty;
            }
            var nameA = a.name.toLowerCase();
            var nameB = b.name.toLowerCase();
            if (nameA > nameB) return 1;
            if (nameA < nameB) return -1;
            return 0;
          });

          if (category.name === "Side") {
            sideCards = catCards;
          } else {
            cards.push(...catCards);
          }
        }
      }

      while (cards.length) {
        let newPage = {
          cards: cards.splice(0, 24),
        };

        newPages.push(newPage);
      }

      if (sideCards.length > 0) {
        sideCards = sideCards.map((sideCard) => {
          return { ...sideCard, isSide: true };
        });
        if (newPages.length === 1) {
          while (sideCards.length) {
            let newPage = {
              cards: sideCards.splice(0, 24),
            };

            newPages.push(newPage);
          }
        } else if (newPages.length > 1) {
          let lastPage = newPages[newPages.length - 1];
          if (lastPage?.cards?.length + sideCards.length + 1 > 24) {
            while (sideCards.length) {
              let newPage = {
                cards: sideCards.splice(0, 24),
              };

              newPages.push(newPage);
            }
          } else {
            lastPage.cards.push({}, ...sideCards);
          }
        }
      }

      setPages(newPages);
    };

    go();
    // eslint-disable-next-line
  }, []);

  return (
    <Grid container spacing={2}>
      {pages?.length > 0 &&
        pages.map((page, index) => (
          <Grid item xs={12} md={6}>
            <IndividualView
              key={index}
              title={deck?.name}
              page={index + 1}
              cards={page?.cards}
            />
          </Grid>
        ))}
    </Grid>
  );
}

function IndividualView(props) {
  const title = props?.title || "";
  const page = props?.page || 0;
  const cards = props?.cards || [];
  const canvas = useRef();
  const [image, setImage] = useState(null);

  const loadImage = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        resolve(img);
      };
      img.onerror = () => reject(new Error(`load ${url} fail`));
      if (url.startsWith("https://")) {
        img.crossOrigin = "annonymous";
      }
      img.src = url;
    });
  };

  const drawImage = (options) => {
    const context = canvas.current.getContext("2d");
    // And this is the key to this solution
    // Always remember to make a copy of original object, then it just works :)
    const myOptions = Object.assign({}, options);

    if (myOptions.qty) {
      return loadImage(myOptions.uri).then((img) => {
        context.drawImage(
          img,
          myOptions.x,
          myOptions.y,
          myOptions.sw,
          myOptions.sh
        );

        if (myOptions.afterLoad) {
          myOptions.afterLoad(context);
        }

        let qtyUrl = `${getEnvironmentVariable(
          "SYSTEM_IMAGES_CLOUDFRONT"
        )}/images/assets/CardQty${
          myOptions.qty > 9 ? "9plus" : myOptions.qty
        }.png`;

        return loadImage(qtyUrl).then((img) => {
          context.drawImage(
            img,
            myOptions.x + myOptions.sw - 15,
            myOptions.y + myOptions.sh - 15,
            30,
            30
          );

          if (myOptions.isSide) {
            return loadImage(
              `${getEnvironmentVariable(
                "SYSTEM_IMAGES_CLOUDFRONT"
              )}/images/assets/CardSide.png`
            ).then((img) => {
              context.drawImage(
                img,
                myOptions.x + myOptions.sw - 50,
                myOptions.y + myOptions.sh - 15,
                30,
                30
              );
            });
          }
        });
      });
    } else {
      return loadImage(myOptions.uri).then((img) => {
        context.drawImage(
          img,
          myOptions.x,
          myOptions.y,
          myOptions.sw,
          myOptions.sh
        );

        if (myOptions.afterLoad) {
          myOptions.afterLoad(context);
        }
      });
    }
  };

  const drawText = (options) => {
    const context = canvas.current.getContext("2d");
    context.font = options.font || "22px Commando";
    context.fontWeight = options.font || "700";
    context.fillText(options.text, options.x, options.y);
  };

  useEffect(() => {
    const go = async () => {
      setImage(null);
      await drawImage({
        uri: `${getEnvironmentVariable(
          "SYSTEM_IMAGES_CLOUDFRONT"
        )}/images/assets/UGN_DECK_BACKGROUND.jpg`,
        x: 0,
        y: 0,
        sw: canvasWidth,
        sh: canvasHeight,
      });

      drawText({
        text: "© UVS Games LLC",
        x: 17,
        y: canvasHeight - 24,
      });
      drawText({
        text: "play.mhacardgame.com",
        x: canvasWidth - 255,
        y: canvasHeight - 24,
      });

      let images = [...defaultImages];

      try {
        let promises = [];
        for (let i = 0; i < images.length; i++) {
          let image = images[i];
          delete image.uri;
          delete image.qty;
          if (cards?.[i]) {
            if (cards[i].imageFile?.cloudFrontDomain) {
              image.uri = `${cards[i].imageFile.cloudFrontDomain}${
                cards[i].imageFile.sizes?.large || cards[i].imageFile.filename
              }`;
              image.qty = cards[i].qty;
              image.isSide = cards[i].isSide;
            }
          }
          if (!image.uri) {
            image.uri = `${getEnvironmentVariable(
              "SYSTEM_IMAGES_CLOUDFRONT"
            )}/images/assets/cardback.png`;
          }
          promises.push(drawImage(image));
        }

        await Promise.all(promises);
      } catch (err) {
        console.log(err);
        console.log(err.stack);
      }

      let can = canvas.current;
      let url = can.toDataURL("image/png");
      setImage(url);
    };

    go();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <canvas
        id={`socialCanvas${page}`}
        ref={canvas}
        height={canvasHeight}
        width={canvasWidth}
        style={{ display: "none" }}
      />
      <Box sx={{ width: "100%", paddingTop: "100%", poition: "relative" }}>
        {image && (
          <Box sx={{ position: "relative", marginTop: "-100%" }}>
            <a
              href={image}
              download={`${
                title ? title.replace(/\W/g, "") : "social_canvas"
              }_${page}.png`}
            >
              <img
                alt={`Social Canvas ${page}`}
                src={image}
                style={{
                  width: "100%",
                  maxWidth: "100%",
                }}
              />
            </a>
          </Box>
        )}
      </Box>
    </>
  );
}
